module.exports = __webpack_public_path__ + "public/media/creator-right.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/creator-right.png
// module id = ./images/services/creator-right.png
// module chunks = 0